import * as React from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';
import {Alert, Box, Button, CircularProgress, Container, TextField, Typography} from '@mui/material';
import {Sessions} from '../../controllers';
import {CONST, TokenValidator} from '../../utils';

export default function Login() {
    const nav = useNavigate();
    const {Login: context} = useOutletContext();
    const [credential, setCredential] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [error, setError] = React.useState('');

    const accept = React.useCallback(async token => {
        if (!await context.validate(token)) return false;
        context.didLogin(true);
        nav('main', {replace: true});
        return true;
    }, [context, nav]);

    React.useEffect(() => { TokenValidator.GetStaffUser().then(accept); }, [accept]);

    const submit = async event => {
        event.preventDefault();
        setBusy(true);
        setError('');
        const response = await Sessions.Direct(credential);
        setBusy(false);
        if (!response || !response.success) return setError(response ? response.message : 'Login failed.');
        if (!await context.validate(response.token)) return setError('Tracking Station permission is required.');
        localStorage.setItem(CONST.STORAGE_KEYS.STAFF_LOGIN, JSON.stringify(response.token));
        await accept(response.token);
    };

    return (
        <Container maxWidth='xs'>
            <Box component='form' onSubmit={submit} sx={{mt: 8, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Typography variant='h5'>BOM Automatic Printing - Sign in</Typography>
                {error && <Alert severity='error'>{error}</Alert>}
                <TextField required autoFocus type='password' label='Credential' value={credential}
                    onChange={event => setCredential(event.target.value)} disabled={busy} />
                <Button type='submit' variant='contained' disabled={busy}>
                    {busy ? <CircularProgress size={24} /> : 'Submit'}
                </Button>
            </Box>
        </Container>
    );
}
